
const GallerySamples = {
  wordpress1: {id: '5tdm_xyz-611645673',
        desc: '<i>The book that started it all</i>, printed from a <b>WordPress</b> travel blog.'},
  blogger1: {id: 'svfieldtrip_blogspot_com-762906699', desc: '<i>Circumnavigation in many volumes</i>, printed from a <b>Blogger</b> sailing blog.'},
  instagram1: {id: 'instagram_com_2Fsimplycycling-414131224', desc: '<i>Tragic cycling tale</i>, in a book printed from <b>Instagram</b> with captions.'},
  squarespace1: {id: 'www_hotspot-hunter_com-456254154', desc: '<i>A book good enough to eat</i>, printed from a <b>Squarespace</b> foodie blog'},
  // plus these in gallery
  blogger2: {id: 'billwright510climbing_blogspot_com-587173134', desc: '<i>Awesome climbing journal,</i> printed from a <b>Blogger</b> blog.'},
  wordpress2: {id: 'adventureswithdougandjackie_com-772080844', desc: '<i>A couple in their RV</i>, now in a <b>Wordpress</b> blog book.'},
  wordpress3: {id: 'cyclingtoalaska_com-47099356', desc: '<i>Long distance touring</i>, printed from a <b>Wordpress</b> blog.'},
}

const GalleryItems = [
  // thumbs under book view
  GallerySamples.wordpress1,
  GallerySamples.blogger1,
  GallerySamples.instagram1,
  GallerySamples.squarespace1,
  // plus these in gallery
  GallerySamples.blogger2,
  GallerySamples.wordpress2,
  GallerySamples.wordpress3
]

export {
  GalleryItems
}



// WEBPACK FOOTER //
// ./src/promotion.js